import type { CountryConfigurationUrls } from '@rover/rsdk/src/apiClient/latest';

export type BookingFeeContext = 'search' | 'seo' | 'sitter-profile' | 'cms';

export const getBookingFeeLearnMoreUrl = (countryConfigUrls?: CountryConfigurationUrls): string => {
  return (
    countryConfigUrls?.localizedLinkUrls?.['what-are-the-service-fees'] ||
    countryConfigUrls?.localizedLinkUrls?.whatAreTheServiceFees ||
    ''
  );
};
